/**
 * The commands a button started that ended (`{t:"runEnded"}`, server/runWatch.ts),
 * as the board socket delivered them (admins only), newest first. The tmux
 * view's off-screen run waits on its session's here instead of polling the list.
 * Module-level, like lib/gitPushes.ts.
 */
import { ref } from "vue";
import type { ServerEvent } from "@shared/types.js";

export type RunEnded = Omit<Extract<ServerEvent, { t: "runEnded" }>, "t">;

/** How many are kept, newest first, across every repo. */
const KEEP = 50;

export const runEnds = ref<RunEnded[]>([]);

export function runEnded(end: RunEnded): void {
  runEnds.value = [end, ...runEnds.value].slice(0, KEEP);
}
